<rcl-modal
	id="session-timeout-rcl-modal"
	[show]="timeoutExtendModal"
	[attr.aria-hidden]="!timeoutExtendModal"
	[attr.tabindex]="timeoutExtendModal ? '0' : '-1'"
	(onClose)="timeoutExtendModalHandler(); timeoutExtendModal = false"
	[mobileFullScreen]="false"
	[topModal]="true"
>
	<rcl-modal-content id="session-timeout-rcl-modal__content">
		<rcl-modal-title id="session-timeout-rcl-modal__content__title">{{
			resourceBundle ? resourceBundle['time.out.header.still.there.question'] : 'Your session is about to expire.'
		}}</rcl-modal-title>
		<p id="session-timeout-rcl-modal__content__inactivity-message" class="rcl-center-md rcl-p">
			{{ resourceBundle ? resourceBundle['time.out.message.15.minutes.inactivity'] : 'If no action is taken, you will be logged out in ' }}
			<span id="session-timeout-rcl-modal__content__inactivity-message__minutes" class="countdown-numbers">{{ minutes }}</span>
			{{ minutesText }}
			<span id="session-timeout-rcl-modal__content__inactivity-message__seconds" class="countdown-numbers">{{ secondsTwoDigits }}</span>
			{{ resourceBundle ? resourceBundle['time.out.message.15.minutes.inactivity3'] : 'seconds' }}
		</p>
	</rcl-modal-content>
	<rcl-modal-actions id="session-timeout-rcl-modal__actions">
		<button
			id="session-timeout-rcl-modal__actions__extend-time"
			(click)="timeoutExtendModalHandler(); timeoutExtendModal = false"
			class="rcl-button-secondary"
		>
			{{ resourceBundle ? resourceBundle['time.out.label.extend.time'] : 'Stay signed in' }}
		</button>
		<button
			id="session-timeout-rcl-modal__actions__log-out"
			(click)="logoutFromExtendModalHandler(); timeoutExtendModal = false"
			class="rcl-button-tertiary"
		>
			{{ resourceBundle ? resourceBundle['time.out.button.log.out'] : 'Log Out' }}
		</button>
	</rcl-modal-actions>
</rcl-modal>

<rcl-modal
	id="session-timeout-rcl-modal__dashboard"
	[show]="timeoutEndedModal"
	[attr.aria-hidden]="!timeoutEndedModal"
	[attr.tabindex]="timeoutEndedModal ? '0' : '-1'"
	(onClose)="timeoutEndedModalHandler(); timeoutEndedModal = false"
	[mobileFullScreen]="false"
	[topModal]="true"
>
	<rcl-modal-content id="session-timeout-rcl-modal__dashboard__content">
		<rcl-modal-title id="session-timeout-rcl-modal__dashboard__content__title">{{
			resourceBundle ? resourceBundle['time.out.session.title'] : 'Your session has expired.'
		}}</rcl-modal-title>
	</rcl-modal-content>
	<rcl-modal-actions id="session-timeout-rcl-modal__dashboard__actions">
		<button
			id="session-timeout-rcl-modal__dashboard__actions__dashboard"
			(click)="timeoutEndedModalHandler(); timeoutEndedModal = false"
			class="rcl-button-secondary"
		>
			{{ resourceBundle ? resourceBundle['button.dashboard'] : 'Dashboard' }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
